export default __webpack_public_path__ + "static/media/Dinosaurs_16.29d356cd.png";